import React from 'react';
import localeText from '@locale';

const Content = ({configData}) => (
  <div className='landing-page-mobile-content'>
    <div className='card'>
      {
        configData.Cards.map((card) => (
          <div
            className='card-item'
            onClick={() => window.open(card.url)}
          >
            <div className='card-item-header'>
              <img src={require(`~/${card.image}`)} alt={card.name} className='card-item-header-image' />
              <span className='card-item-header-name'>{card.name}</span>
            </div>
            <div className='card-item-description'>{card.description}</div>
          </div>
        ))
      }
    </div>
    <div className='product'>
      <div className='product-title'>{localeText('COMMON.TXT_ALL_PRODUCTS')}</div>
      <div className='product-lists'>
        {
          configData.Products.map((product) => (
            <div className='product-list-item'>
              <div className='product-list-item-category'>{product.category}</div>
              <div className='product-list-item-elements'>
                {product.item.map((element) => (
                  <div className='product-list-item-elements-item' onClick={() => window.open(element.url)}>
                    <div className='product-list-item-elements-item-image'>
                      <img src={require(`~/${element.image}`)} alt={element.name} />
                    </div>
                    <div className='product-list-item-elements-item-name'>{element.name}</div>
                    <div className='product-list-item-elements-item-icon'><i className='dpl20_right' /></div>
                  </div>
                ))}
              </div>
            </div>
          ))
        }
      </div>
    </div>
  </div>
);

export default Content;
